import Titles from "../../components/Titles/Titles";
import "./actuality.css";
import ItemActuality from "../../components/Actus/ActuCard/ActuCard";

const Actuality = ({ actus }) => {
	
	return (
		<div className="container containerActu">
			<Titles title={"Les actualités"} color={"white"} />
			<div className="blocActuality">
				{actus.map((actu, i) => {
					return <ItemActuality key={i} actu={actu} />;
				})}
			</div>
			{actus.length === 0 && (
				<p style={{ color: "white", textAlign: "center", fontSize: "18px", marginTop: "40px" }}>
					Aucune actualités pour le moment. Revenez bientôt !
				</p>
			)}

			    

		</div>
	);
};

export default Actuality;
